export const SEARCH_RESULTS_FIXED_HEADER_HEIGHT = '66px';
